import { AndromedaMenuItem } from '@ansys-internal/awf-angular/contributions';
import { Icons } from '@ansys-internal/awc-angular/icons';
import { DialogService } from '@ansys-internal/awf-angular/shared';
import { PopoutService } from '@ansys-internal/awc-angular/popout';
import { FeatureFlagsDialogComponent } from '../../../components/dialogs/feature-flags-dialog/feature-flags-dialog.component';
import { AWFMenuItem } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../contributions.enum';
import { AuthEnvironment } from '@ansys-internal/awf-angular/auth';
import { environment } from 'src/environments/environment';
import { ModalSize } from '@ansys-internal/awc-angular/modals';

@AWFMenuItem({
  id: ContributionsEnum.USER_PROFILE_MENU_FEATURE_FLAG_MENU_ITEM,
  priority: 100,
})
export class FeatureFlagMenu implements AndromedaMenuItem {
  type = ContributionsEnum.USER_PROFILE_MENU_FEATURE_FLAG_MENU_ITEM;
  priority = 100;
  id = 'feature-flags-dialog';
  prefixIcon = {
    icon: Icons.BUG,
  };
  text = 'Feature Flags';

  constructor(
    private dialog: DialogService,
    private popoutService: PopoutService
  ) {}

  canActivate(): boolean {
    return [AuthEnvironment.DEV, AuthEnvironment.TEST].includes(
      environment.type
    );
  }

  execute(): Promise<unknown> {
    return new Promise<void>((resolve) => {
      this.dialog.open(FeatureFlagsDialogComponent, {
        size: ModalSize.FULL_SCREEN,
        title: 'Feature Flags',
      });
      this.popoutService.closeAll();
      resolve();
    });
  }
}
